import { ReactElement } from "react"

/**
 * Displayed when invalid URL entered. Called
 * by app router in `src/router`. Use in conjuction
 * wtih `ErrorBoundary` from `react-error-boundary`
 *
 * @example
 * <ErrorBoundary FallbackComponent={AppErrorBoundary}>
 *     <App>
 * </ErrorBoundary>
 */
const AppErrorBoundary = (): ReactElement => (
    <div>Whoops! Something went wrong :(</div>
)

export default AppErrorBoundary
